module.exports = __webpack_public_path__ + "img/pumping-activities-icon2.0d295f14.png";